export default "__VITE_ASSET__JvklKA7J__"